<template>
  <div>
    <form-table style="padding: 0; margin-top: 10px">
      <template slot="table">
        <v-data-table
            ref="table"
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItens"
            :options.sync="paginacaoInterna"
            :loading="false"
            no-data-text="Não há cobranças registradas para o atendimento."
            class="table-list table-dense"
            hide-default-footer
            @click:row="tratarEventoAcessar">
          <template #item.codigo="{ item }">
            <span class="max-label">{{ item.codigo | textoSemValor }}</span>
          </template>
          <template #item.valorTotal="{item}">
            <span>{{ item.valorTotal | valorParaReal }}</span>
          </template>
          <template #item.valorPago="{item}">
            <span>{{ item.valorPago | valorParaReal }}</span>
          </template>
          <template #item.status="{item}">
                    <span :class="['d-inline-block text-truncate max-15', 'status-cobranca-' + item.status]">
                      {{ item.status | filterEnum(statusCobranca) }} <span
                        v-if="item.dataPagamento">({{ item.dataPagamento | filterDataHora }})</span></span>
          </template>
          <template #item.dataVencimento="{item}">
            <v-tooltip top v-if="item.isVencido">
              <template #activator="{ on }">
              <span class="cobranca-vencida"
                    v-on="on">{{ item.dataVencimento | filterDate }}</span>
              </template>
              Cobrança vencida!
            </v-tooltip>
            <span v-else>{{ item.dataVencimento | filterDate }}</span>
          </template>
          <template #item.acoes="{  }">
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="mobile">Acessar</span>
          </template>
        </v-data-table>
      </template>

      <template slot="footer">
        <div class="pagination">
          <v-pagination
              v-if="paginas > 1"
              v-model="paginacaoInterna.page"
              total-visible="7"
              :length="paginas"
          />
          <v-spacer v-if="paginas <= 1"/>
          <div class="select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.size"/>
          </div>
        </div>
      </template>

    </form-table>
  </div>
</template>

<script>
import {statusCobranca} from '@/core/constants'
import mutationTypes from '@/core/constants/mutationTypes'
import FormTable from '@/views/components/FormTable.vue'

export default {
    name: 'OdontogramaGerenciarCobrancasTabela',
    components: {FormTable},
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],
    data() {
        return {
            colunas: [
                {
                    text: 'Código',
                    value: 'codigo',
                    sortable: false,
                    align: 'left',
                    class: 'gray--text'
                },
                {
                    text: 'Valor',
                    value: 'valorTotal',
                    sortable: false,
                    align: 'left',
                    width: '120px',
                    class: 'gray--text'
                },
                {
                    text: 'Valor Pago',
                    value: 'valorPago',
                    sortable: false,
                    align: 'left',
                    width: '120px',
                    class: 'gray--text'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'left',
                    class: 'gray--text'
                },
                {
                    text: 'Vencimento',
                    value: 'dataVencimento',
                    sortable: false,
                    align: 'left',
                    class: 'gray--text'
                },
                {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'right',
                    class: 'gray--text'
                }
            ],
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
            statusCobranca
        }
    },
    methods: {
        tratarEventoAcessar(item) {
            this.$emit('acessar', item)
        },
        resetaPage() {
            this.$store.commit(mutationTypes.COBRANCA.RESETA_PAGE_ATENDIMENTO)
        },
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true,
        },
    },
}
</script>


<style scoped lang="stylus">
.max-15
  max-width 15vw

.max-label
  padding-top 5px
  display inline-block
  max-width 120px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis


@media (max-width: 720px)
  .max-15
    max-width 40vw !important
</style>